/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { OmitFunctions } from 'src/core/stores/types';

export type UserData = OmitFunctions<Omit<UserStore, 'id' | 'isAccountMigrated' | 'initials'>>;

/**
 * An user store factory object.
 *
 * @param id The id of the user to create.
 * @param user The user data.
 */
export class UserStore {
    public id: string;

    public principalId: string;

    public email: string;

    public name: string;

    public photo: string;

    public defaultTenantId: string;

    constructor(id: string, user: Partial<UserData>) {
        this.id = id;
        this.name = user.name;
        this.email = user.email;
        this.photo = user.photo;
        this.principalId = user.principalId;
        this.defaultTenantId = user.defaultTenantId;
    }

    /**
     * Returns the initials of the user name.
     */
    public get initials() {
        return this.name
            .split(' ')
            .filter(namePart => namePart.length > 0)
            .map(namePart => namePart[0])
            .slice(0, 2)
            .join('');
    }
}
